import { screenHeight } from "../constants";

export type Rect = {
  readonly type: string;
  readonly left: number;
  readonly right: number;
  readonly top: number;
  readonly bottom: number;
};

export function createRect(
  type: string,
  x: number,
  y: number,
  width: number,
  height: number,
): Rect {
  return {
    type,
    left: x,
    right: x + width,
    top: y,
    bottom: y + height,
  };
}

/**
 * 衝突判定
 *
 * 面倒なので矩形、プレイヤーvsそれ以外の衝突判定のみ
 */
export class CollisionManager {
  private collideTargets = new Set<Rect>();
  constructor(private height: number) {}

  add(rect: Rect) {
    this.collideTargets.add(rect);
  }

  remove(rect: Rect) {
    this.collideTargets.delete(rect);
  }

  check(rect: Rect) {
    const result: Rect[] = [];
    this.collideTargets.forEach((r) => {
      if (
        r.left < rect.right &&
        rect.left < r.right &&
        r.top < rect.bottom &&
        rect.top < r.bottom
      )
        result.push(r);
    });
    return result;
  }

  bottomBoundOf(type: string, rect: Rect) {
    let bottom = this.height;
    this.collideTargets.forEach((r) => {
      if (r.type !== type) return;
      if (r.left < rect.right && rect.left < r.right && rect.top < r.bottom) {
        bottom = Math.min(bottom, r.top);
      }
    });
    return bottom;
  }

  topBoundOf(type: string, rect: Rect) {
    let top = 0;
    this.collideTargets.forEach((r) => {
      if (r.type !== type) return;
      if (r.left < rect.right && rect.left < r.right && r.top < rect.bottom) {
        top = Math.max(top, r.bottom);
      }
    });
    return top;
  }
}
